import { processDocSchema } from '../../../shared/sync/processes';
import { rxdbFromZod } from '../lib/rxdbFromZod';
import { type z } from 'zod/v4';

export type ProcessDoc = Omit<z.infer<typeof processDocSchema>, '_deleted'>;

export const processSchema = rxdbFromZod(processDocSchema, {
  indexes: ['updatedAt', 'workspaceId'],
  primaryKey: 'id',
  stringMaxLength: { id: 36, userId: 64, workspaceId: 36 },
  version: 1,
});
